import { render, staticRenderFns } from "./FollowUpLeadBox.vue?vue&type=template&id=5d9fdda9&"
import script from "./FollowUpLeadBox.vue?vue&type=script&lang=js&"
export * from "./FollowUpLeadBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports